import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';

export const MainHeading = styled.div`
    font-size: 18px;
    margin: 18px 0 0 0;
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    opacity: 1;
    ${media.mobileDevice` 
    margin: 10px 10px 0 0;
    `}
`;

export const SubHeading = styled.div`
    font-size: 16px;
    padding-top: 10px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    opacity: 1;
    ${media.mobileDevice`
    padding-top: 20px;
    `};
`;

export const UserHeading = styled.div`
    font-size: 14px;
    margin: 18px 0 0 0;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
`;

export const To = styled.div`
    font-family: 'AvenirNextWorld Regular';
    margin: 0 0 10px 0;
    text-align: left;
    color: #3c3c3c;
    font-size: 15px;
    opacity: 1;
    display: inline-block;
    ${media.mobileDevice`
    margin: 0;`};
`;

export const CloseIcon = styled(Icon)`
    margin: 18px 0 0 0;
`;

export const Username = styled.div`
    margin: 3px 16px 0 9px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
`;

export const User = styled.div`
    display: inline-flex;
    margin: auto;
    ${media.mobileDevice`
display:inline-block`}
`;

export const Line = styled.div`
    border: 1px solid #707070;
    opacity: 0.3;
    margin-top: 30px;
    background-color: #707070;
    ${media.mobileDevice`
      display: none;
    `}
`;

export const ValidDates = styled.div`
    padding: 14px 0 3px 0;
    font-family: 'AvenirNextWorld Demi';
    text-align: left;
    font-size: 14px
    color: #202124;
    opacity: 1;
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    letter-spacing: -0.12px;
    align-self: center;
`;

export const Designation = styled.div`
    margin: auto;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #202124;
    opacity: 0.7;
    ${media.mobileDevice`
        margin: 0 0 0 6px;`};
`;

export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    right: 0;
    background-color: white;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'flex-end'};
        padding-right: 0px;
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};
    }
    ${media.smalDevice`    
        background-color: #FFFFFF;
          padding: ${(props) =>
              props.ipadPadding ? props.ipadPadding : '0px'};`}
    ${media.mobileDevice` 
        
         background-color: #FFFFFF;
           padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};`}

           button{
            ${media.mobileDevice`
                // width: 90px;
                padding: 0 15px;
                margin: 15px 0 0 10px;
            `}
        }
`;


export const UpdateProxyPopupContainer = styled.div`
    ${media.mobileDevice`
        overflow-y: scroll;
        height: 370px;
    `}
`;